import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.h2`
	font-family: ${props => props.theme.f1};
	font-size: 3.6rem;
	font-weight: 700;
	margin: 1rem 0;
	line-height: 1.2;
	color: rgb(68, 68, 68);
	cursor: pointer;

	${rmq('t')} {
		font-size: 3.4rem;
	}
	${rmq('590')} {
		font-size: 2.6rem;
	}
	${rmq('ml')} {
		font-size: 2.2rem;
	}
	${rmq('mm')} {
		font-size: 2rem;
	}
	${rmq('ms')} {
	}
`;
